export const outPatientLCodeCarveOuts = [
    {Code: "L8680", Description: "Implt neurostim elctr each", Count: 16, CPTMatch: ["63650"]},
    {Code: "63650", Description: "Implant neuroelectrodes", Count: 2, CPTMatch: ["63650"]},
    {Code: "L8687", Description: "Implt nrostm pls gen dua rec", Count: 1, CPTMatch: ["63685"]},
    {Code: "63650", Description: "Implant neuroelectrodes", Count: 2, CPTMatch: ["63685"]},
    {Code: "L8688", Description: "Implt nrostm pls gen dua non", Count: 1, CPTMatch: ["64582"]},
    {Code: "L8680", Description: "Implt neurostim elctr each", Count: 4, CPTMatch: ["64582"]},
    {Code: "L8614", Description: "Cochlear device", Count: 1, CPTMatch: ["69930"]},
    {Code: "27096", Description: "SI Joint Injection", Count: 1, CPTMatch: ["G0260"]},

];